module.exports = __webpack_public_path__ + "img/hzt.9b6c7c48.jpg";